import { Box, Button, Grid, LinearProgress, Link, Typography } from "@mui/material"

import React, { useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { customPalette } from "../../../../../../../theme"
import { IconBox } from "../../../../../../components/custom-icons/icon-box"
import { TabEnum } from "../../../../../../components/tabs/tabs"
import { pagesUrl } from "../../../../../../core/appConstants"
import { BSBimModelListContext } from "../../../../../../core/context/beem-shot/BSBimModel/BSBimModelContextList"
import { OrganizationContext } from "../../../../../../core/context/organization/organization-context"
import { licenseNumberToString } from "../../../../../../core/services/helper-service"
import { resolveUrl } from "../../../../../../core/services/http-service"
import { normalizeTo100 } from "../../../../../offer/OfferCard"

type IProps = {
  handleChange(event: React.SyntheticEvent, newValue: TabEnum): void
}

export function ProjectBeemModelCard({ handleChange }: Readonly<IProps>): React.JSX.Element {
  const navigate = useNavigate()
  const { projectId } = useParams()

  const { organization } = useContext(OrganizationContext)
  const { bsBimModelListByProject } = useContext(BSBimModelListContext)

  return (
    <Box
      display="flex"
      flexDirection="column"
      p={3}
      gap={2}
      width="100%"
      borderRadius={2}
      sx={{ background: customPalette.white }}>
      <Box display="flex" p={1} sx={{ background: customPalette.white, width: "fit-content", borderRadius: 3 }}>
        <IconBox sx={{ height: "50px", width: "50px" }} />
      </Box>
      <Typography variant="subtitle1" sx={{ color: customPalette.lightBlue5 }}>
        Maquettes Beem
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h4">{bsBimModelListByProject.length ?? 0}</Typography>

        <Box>
          <Typography variant="body2">Maquettes numériques importées</Typography>
          <Typography variant="body2" fontSize={12} sx={{ color: customPalette.lightGray2 }}>
            Dont {bsBimModelListByProject.filter((model) => model.variantCount !== 0).length ?? 0} liées à des études carbone
          </Typography>
        </Box>
      </Box>

      <Link
        component="button"
        variant="body2"
        color={customPalette.black}
        textAlign="left"
        onClick={(e) => handleChange(e, TabEnum.PROJECT_BIM_MODEL)}>
        Voir la liste des maquettes
      </Link>

      <Grid container p={1} sx={{ background: customPalette.lightGray6, borderRadius: 3 }}>
        <Grid item xs={8} container flexDirection="column" gap={1} p={1}>
          <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
            <Typography variant="body2">Plus de maquettes ?</Typography>
            <Typography fontSize={12} fontWeight={400} sx={{ color: customPalette.darkBlue3 }}>
              {`${organization?.bsBimModelCounter}/${licenseNumberToString(organization?.bsMaxBimModelCount ?? 0)}`}
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={normalizeTo100(organization?.bsBimModelCounter ?? 0, organization?.bsMaxBimModelCount ?? 0)}
            sx={{
              height: 10,
              flexGrow: 1,
              borderRadius: 5,
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[200],
              "& .MuiLinearProgress-bar": {
                borderRadius: 5,
                backgroundColor: customPalette.darkBlue3,
              },
            }}
          />
        </Grid>

        <Grid item xs={4} display="flex" alignItems="center" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={() =>
              navigate(resolveUrl(pagesUrl.MY_OFFER_PAGE, [], { projectId, tab: TabEnum.PROJECT_GENERAL_INFORMATIONS }))
            }
            sx={{ background: customPalette.lightGreen8, height: "fit-content" }}>
            <Typography variant="body2" sx={{ color: customPalette.mediumGreen3, borderRadius: 8 }}>
              Mettre à niveau
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}
